// extracted by mini-css-extract-plugin
export default {"image":"ZX-z","loaded":"_X-z"};